import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'formatTotal' })
export class FormatTotalPipe implements PipeTransform {
    transform(value: any, exponent: any): any {
        // å¤æ­å¼æ¯å¦åæ³
        if (!value && value !== 0) {
            return '';
        }
        if (exponent.dataType === 'number') {
            // ä¿çå°æ°ç¹åå ä½
            const dataFormat = exponent.format;
            return value.toFixed(Number(dataFormat.substring(1)));
        }
        return value;
    }
}
